// Cache sur le poste (IndexedDB, store "cachedata", expiration 24 h) de la liste d'articles d'un magasin.
// Partagé entre les mouvements de stock et la gestion commerciale : même liste serveur, même clé.
// Le stock (rstck) de cette liste n'est pas fiable : il est relu en base à la sélection de l'article.
import { getData, saveOrUpdateData } from "@/service/indexedDBService";

function cleCatalogue(societe, pidmag) {
    return `cataloguemvtstock${societe}${pidmag}`;
}

export async function lireCatalogueCache(societe, pidmag) {
    if (!societe || !pidmag) return [];
    try {
        const liste = await getData("cachedata", cleCatalogue(societe, pidmag));
        return Array.isArray(liste) ? liste : [];
    } catch (error) {
        console.error('Error reading catalogue cache:', error);
        return [];
    }
}

export async function ecrireCatalogueCache(societe, pidmag, liste) {
    if (!societe || !pidmag || !Array.isArray(liste) || liste.length === 0) return;
    try {
        await saveOrUpdateData("cachedata", cleCatalogue(societe, pidmag), liste);
    } catch (error) {
        console.error('Error saving catalogue cache:', error);
    }
}
